import api from '@/services/api'

export default {
  getInvoices(params) {
    let queryString = this.createInvoicesQueryString(params);
    return api.get(`/invoices${queryString}`);
  },

  exportInvoices(params) {
    let queryString = this.createInvoicesQueryString(params) + '&export=true';

    return api({
      url: `/invoices${queryString}`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  createInvoicesQueryString(params) {
    let queryString = `?page=${params.page || 1}`;

    if (params.customer) {
      queryString += `&customer=${params.customer}`;
    }

    if (params.period) {
      if (params.startDate) {
        const startDate = new Date(params.startDate);
        queryString += `&startDate=${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
      }

      if (params.endDate) {
        const endDate = new Date(params.endDate);
        queryString += `&endDate=${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
      }
    }

    if (params.code) {
      queryString += `&code=${params.code}`;
    }

    if (params.attendanceCode) {
      queryString += `&attendanceCode=${params.attendanceCode}`;
    }

    if (params.seller) {
      queryString += `&seller=${params.seller}`;
    }

    return queryString;
  },

  getAbcCurveCustomers(customer) {
    let filter = '';
    if (customer) {
      filter = `?customer=${customer}`;
    }

    return api.get('/invoices/abc-curve/customers' + filter);
  },

  getAbcCurveCustomersDetails(customerId) {
    return api.get(`/invoices/abc-curve/customers/${customerId}`);
  },

  exportAbcCurveCustomers(customer) {
    let filter = '';
    if (customer) {
      filter = `&customer=${customer}`;
    }

    return api({
      url: '/invoices/abc-curve/customers?export=true' + filter,
      method: 'GET',
      responseType: 'blob',
    })
  },

  getAbcCurveProducts(product) {
    let filter = '';
    if (product) {
      filter = `?product=${product}`;
    }
    
    return api.get('/invoices/abc-curve/products' + filter);
  },

  getAbcCurveProductsDetails(productId) {
    return api.get(`/invoices/abc-curve/products/${productId}`);
  },

  exportAbcCurveProducts(product) {
    let filter = '';
    if (product) {
      filter = `&product=${product}`;
    }

    return api({
      url: '/invoices/abc-curve/products?export=true' + filter,
      method: 'GET',
      responseType: 'blob',
    })
  },

  getGoals(period) {
    const date = new Date(period);
    const month = date.getMonth();
    const year = date.getFullYear();

    return api.get(`/invoices/goals?period=${month}-${year}`);
  },

  exportGoals(period) {
    const date = new Date(period);
    const month = date.getMonth();
    const year = date.getFullYear();

    return api({
      url: `/invoices/goals?period=${month}-${year}&export=true`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  getCommissions(params) {
    let queryString = `?page=${params.page || 1}`;

    if (params.startDate) {
      const startDate = new Date(params.startDate);
      queryString += `&startDate=${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
    }

    if (params.endDate) {
      const endDate = new Date(params.endDate);
      queryString += `&endDate=${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
    }

    return api.get('/invoices/commissions' + queryString);
  },

  exportCommissions(params) {
    let queryString = '?export=true';

    if (params.startDate) {
      const startDate = new Date(params.startDate);
      queryString += `&startDate=${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
    }

    if (params.endDate) {
      const endDate = new Date(params.endDate);
      queryString += `&endDate=${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
    }

    return api({
      url: '/invoices/commissions' + queryString,
      method: 'GET',
      responseType: 'blob',
    })
  }
}